/**
 * ScrollToTop Component (#778)
 *
 * Scrolls to top on route changes. Standard mobile/PWA behavior.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
